"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hooks_1 = require("common/hooks");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_hook_form_1 = require("react-hook-form");
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
const updateScript_1 = require("@/utils/updateScript");
const schema_1 = __importDefault(require("./schema"));
const TranslateAllButton_1 = __importDefault(require("../TranslateAllButton"));
const MAX_RETRIES = 3;
const INITIAL_RETRY_DELAY = 1000; // 1 second
const retryWithBackoff = (operation_1, ...args_1) => __awaiter(void 0, [operation_1, ...args_1], void 0, function* (operation, maxRetries = MAX_RETRIES, initialDelay = INITIAL_RETRY_DELAY) {
    let lastError = null;
    for (let attempt = 0; attempt < maxRetries; attempt++) {
        try {
            if (attempt > 0) {
                console.log(`Retry attempt ${attempt + 1}/${maxRetries}`);
            }
            return yield operation();
        }
        catch (error) {
            lastError = error;
            console.log(`Failed attempt ${attempt + 1}/${maxRetries}:`, error);
            if (attempt === maxRetries - 1)
                break;
            const delay = initialDelay * Math.pow(2, attempt);
            console.log(`Waiting ${delay}ms before next retry...`);
            yield new Promise((resolve) => setTimeout(resolve, delay));
        }
    }
    throw lastError;
});
function getDirtyValues(dirtyFields, values) {
    const dirtyValues = Object.keys(dirtyFields).reduce((prev, key) => {
        if (!dirtyFields[key])
            return prev;
        return Object.assign(Object.assign({}, prev), { [key]: typeof dirtyFields[key] === "object"
                ? getDirtyValues(dirtyFields[key], values[key])
                : values[key] });
    }, {});
    return dirtyValues;
}
const MultipleScriptsForm = ({ langId, projectId, segmentId, selectedScripts, }) => {
    const [toast, setToast] = (0, react_1.useState)({
        status: null,
        timer: null,
    });
    const [rerunTranslated, setRerunTranslated] = (0, react_1.useState)(false);
    const alert = (0, standard_1.useAlert)();
    const [operationMode] = (0, hooks_1.useSessionStorage)("operationMode", undefined);
    const form = (0, react_hook_form_1.useForm)();
    const { handleSubmit, control, formState, reset, getValues } = form;
    (0, react_1.useEffect)(() => {
        if (formState.isDirty) {
            setBlockNavigation(true);
        }
    }, [formState.isDirty]);
    const save = (0, react_1.useCallback)((values, status) => __awaiter(void 0, void 0, void 0, function* () {
        return retryWithBackoff(() => __awaiter(void 0, void 0, void 0, function* () {
            // TESTING ONLY - Remove this block after testing
            // const TEST_MODE = true; // Set to true to test retry logic
            // if (TEST_MODE) {
            //   const testError = new Error("Simulated cold start error");
            //   console.log("Forcing first attempt to fail for testing");
            //   throw testError;
            // }
            var _a, _b;
            yield (0, updateScript_1.updateScript)({
                projectId,
                segmentId: values.segmentId,
                scriptId: values.scriptId,
                data: Object.assign(Object.assign({}, values), { translationStatus: {
                        [langId]: status !== undefined
                            ? status
                            : (_a = values.translationStatus) === null || _a === void 0 ? void 0 : _a[langId],
                    }, translationIgnore: {
                        [langId]: (_b = values.translationIgnore) === null || _b === void 0 ? void 0 : _b[langId],
                    } }),
            });
        }));
    }), [langId, projectId, segmentId]);
    (0, react_1.useEffect)(() => {
        form.reset();
    }, []);
    const errorModal = (0, standard_1.useErrorModal)();
    const handleSave = (0, react_1.useCallback)((formValues) => __awaiter(void 0, void 0, void 0, function* () {
        if (!langId) {
            return;
        }
        const dirtyValues = getDirtyValues(formState.dirtyFields, formValues);
        yield Promise.all(selectedScripts.map((script) => {
            var _a, _b, _c;
            const values = Object.assign(Object.assign({}, script), dirtyValues);
            if (operationMode === "translator") {
                if (!((_a = script.translationStatus) === null || _a === void 0 ? void 0 : _a[langId])) {
                    return save(values, "translated");
                }
                else if (((_b = script.translationStatus) === null || _b === void 0 ? void 0 : _b[langId]) === "translated") {
                    return save(values, undefined);
                }
            }
            else if (operationMode === "corrector") {
                if (((_c = script.translationStatus) === null || _c === void 0 ? void 0 : _c[langId]) === "translated") {
                    return save(values, "corrected");
                }
            }
            else {
                return save(values, undefined);
            }
        })).catch((e) => {
            errorModal({
                error: e,
                internalMessage: "Error while submitting script",
                userMessage: "テキスト情報の保存に失敗しました。この問題が繰り返す場合は管理者にお問い合わせください。",
            });
        });
    }), [langId, operationMode, save, selectedScripts, formState.dirtyFields]);
    const parameter = (0, react_1.useMemo)(() => ({
        schema: (0, schema_1.default)({
            langId,
            autoSaveHandler: langId ? handleSubmit(handleSave) : undefined,
        }),
    }), [langId, operationMode, projectId, handleSave]);
    const { schema } = parameter;
    const hasErrors = Object.keys(formState.errors).length > 0;
    const { setBlockNavigation } = (0, standard_1.useBlockNavigation)({
        blockLevel: "browser",
        onAppNavigate: handleSubmit(handleSave),
    });
    (0, react_1.useEffect)(() => {
        if (formState.isSubmitSuccessful) {
            setBlockNavigation(false);
            const timer = setTimeout(() => {
                setToast({ status: null, timer: null });
            }, 3000);
            setToast({ status: "success", timer });
            // To reset dirty state
            // form.reset(data);
        }
        else if (formState.isSubmitting) {
            if (toast.timer) {
                window.clearTimeout(toast.timer);
            }
            setToast({
                status: "submitting",
                timer: null,
            });
        }
    }, [formState.isSubmitting, formState.isSubmitSuccessful]);
    const untranslatedScripts = selectedScripts.filter((script) => { var _a; return !((_a = script.translations) === null || _a === void 0 ? void 0 : _a[langId]); });
    const [radioId] = (0, react_1.useState)(() => Math.random().toString(36).slice(2));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "tile" },
            react_1.default.createElement("div", { className: "card tile" },
                react_1.default.createElement("div", { className: "card-content", style: { padding: "0.5rem 1rem" } },
                    react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, form),
                        react_1.default.createElement("form", { className: "adjust-width-expand", noValidate: true },
                            react_1.default.createElement(schemaComponents_1.Field, { control: control, schema: schema }))),
                    react_1.default.createElement(TranslateAllButton_1.default, { scripts: rerunTranslated ? selectedScripts : untranslatedScripts, langId: langId, projectId: projectId, segmentId: segmentId, confirmTitle: "\u9078\u629E\u3055\u308C\u305F\u30C6\u30AD\u30B9\u30C8\u3092\u7FFB\u8A33\u3057\u307E\u3059\u304B?", confirmContent: react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("p", { className: "mb-2" }, "\u7FFB\u8A33\u6587\u304C\u672A\u8A2D\u5B9A\u306E\u5168\u3066\u306E\u30C6\u30AD\u30B9\u30C8\u3092\u3001\u9806\u756A\u306B\u7FFB\u8A33\u3059\u308B\u6A5F\u80FD\u3067\u3059\u3002\u7FFB\u8A33\u5F8C\u3001\u30B9\u30C6\u30FC\u30BF\u30B9\u304C\u300C\u7FFB\u8A33\u6E08\u307F\u300D\u3068\u306A\u308A\u307E\u3059\u3002\u306A\u304A\u3001\u7FFB\u8A33\u6587\u304C\u3059\u3067\u306B\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u30C6\u30AD\u30B9\u30C8\u306B\u3064\u3044\u3066\u306F\u3001\u30B9\u30C6\u30FC\u30BF\u30B9\u306F\u5909\u66F4\u3055\u308C\u307E\u305B\u3093\u3002"),
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { onChange: (e) => {
                                    setRerunTranslated(e.target.checked);
                                }, checked: rerunTranslated, label: "\u7FFB\u8A33\u6E08\u307F\u306E\u30C6\u30AD\u30B9\u30C8\u3082\u518D\u7FFB\u8A33\u3059\u308B", id: `${radioId}-rerun-translated` })) }, "\u3059\u3079\u3066\u7FFB\u8A33")))),
        react_1.default.createElement(react_bootstrap_1.ToastContainer, { position: "bottom-end", containerPosition: "fixed", className: "m-4" },
            react_1.default.createElement(react_bootstrap_1.Toast, { show: !!toast.status, onClose: () => setToast((prev) => (Object.assign(Object.assign({}, prev), { status: null }))) },
                react_1.default.createElement(react_bootstrap_1.ToastHeader, null,
                    react_1.default.createElement("strong", { className: "me-auto d-flex align-items-center" }, toast.status === "submitting" ? (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Spinner, { className: "me-2", animation: "border", role: "status", style: { width: "1rem", height: "1rem" } }),
                        "\u30BB\u30FC\u30D6\u4E2D")) : (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("i", { className: "mdi mdi-check-circle-outline me-2 text-success", style: { width: "1rem", height: "1rem" } }),
                        "\u30BB\u30FC\u30D6\u6210\u529F")))),
                react_1.default.createElement(react_bootstrap_1.ToastBody, null, toast.status === "submitting"
                    ? "変更内容を保存しています..."
                    : "変更内容を保存しました。")))));
};
exports.default = MultipleScriptsForm;
